export default __webpack_public_path__ + "static/media/Comp 2_00047.a8994979.png";